import { Card } from '../ui/card';
import { Target } from 'lucide-react';

export const ClarityScoreCard = ({ currentScore, clarityLevel, selectedCount, totalSources, bubbleBreaks }) => (
  <Card className="p-6 sm:p-8 bg-gradient-to-br from-blue-50 to-indigo-50 border-blue-200">
    <div className="flex items-center gap-3 mb-4">
      <Target className="w-6 h-6 sm:w-8 sm:h-8 text-blue-600" />
      <h2 className="text-xl sm:text-2xl font-serif font-bold">Clarity Score</h2>
    </div>

    <div className="text-center mb-6">
      <div className="text-5xl sm:text-6xl lg:text-7xl font-bold text-blue-600 mb-2" data-testid="clarity-score">
        {currentScore}
      </div>
      <div className={`text-lg sm:text-xl font-medium mb-1 ${clarityLevel.color}`}>
        {clarityLevel.level}
      </div>
      <p className="text-sm text-gray-600">{clarityLevel.desc}</p>
    </div>

    <div className="bg-white rounded-lg p-4 space-y-3">
      <div className="flex justify-between items-center">
        <span className="text-sm text-gray-600">Source Diversity</span>
        <span className="font-semibold">{selectedCount}/{totalSources}</span>
      </div>
      <div className="flex justify-between items-center">
        <span className="text-sm text-gray-600">Bubble Breaks</span>
        <span className="font-semibold">{bubbleBreaks || 0}</span>
      </div>
      <div className="flex justify-between items-center">
        <span className="text-sm text-gray-600">Articles Read</span>
        <span className="font-semibold">Coming Soon</span>
      </div>
    </div>
  </Card>
);
